import { handleColorType } from '@quizzach/styles';
import { useTheme } from 'styled-components';

export const Search = ({
	color,
	size,
	className,
}: {
	color?: string;
	size?: number;
	className?: string;
}) => {
	const theme = useTheme();

	return (
		<svg
			width={size || '42'}
			height={size || '42'}
			viewBox='0 0 42 42'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={className}
		>
			<path
				d='M9.67118 17.9384C8.76194 14.9941 9.26285 11.7935 11.0287 9.26428L11.6701 8.34568C11.9864 7.89263 11.8757 7.26949 11.4228 6.95385C10.97 6.63822 10.3464 6.74962 10.0301 7.20267L9.3887 8.12128C7.26964 11.1563 6.66855 14.997 7.75964 18.5302L7.99904 19.3055C8.16191 19.8329 8.72186 20.1279 9.24971 19.9645C9.77757 19.8011 10.0734 19.2411 9.91058 18.7136L9.67118 17.9384Z'
				fill={color ? handleColorType(color, theme) : '#00FFC2'}
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M18.1827 30.2577C21.4895 30.2577 24.5494 29.2043 27.0429 27.4158L38.5555 41.6147C38.9175 42.0612 39.5729 42.1296 40.0194 41.7676C40.4659 41.4056 40.5343 40.7502 40.1723 40.3037L28.6476 26.0899C31.5539 23.3339 33.3654 19.4422 33.3654 15.1289C33.3654 6.77343 26.5678 0 18.1827 0C9.79752 0 3 6.77343 3 15.1289C3 23.4843 9.79752 30.2577 18.1827 30.2577ZM18.1827 28.2577C25.47 28.2577 31.3654 22.3731 31.3654 15.1289C31.3654 7.88468 25.47 2 18.1827 2C10.8954 2 5 7.88468 5 15.1289C5 22.3731 10.8954 28.2577 18.1827 28.2577Z'
				fill={color ? handleColorType(color, theme) : '#00FFC2'}
			/>
		</svg>
	);
};
